var getDevice = function getDevice() {
  return {
    isDesktop: !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|SamsungBrowser/i.test(navigator.userAgent.toLowerCase()) && !/Tablet|iPad/i.test(navigator.userAgent.toLowerCase()),
    isMobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|SamsungBrowser/i.test(navigator.userAgent.toLowerCase()),
    isTablet: /Tablet|iPad/i.test(navigator.userAgent.toLowerCase())
  };
};

export { getDevice as default };
//# sourceMappingURL=index.js.map
